import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { distinctUntilChanged, firstValueFrom, map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Timestamp } from '@angular/fire/firestore';
import { ApiService } from 'src/app/core/backend/api.service';
import { IPicksResponsePayload, IStakingResponsePayload } from '@soposopo/sopo-models';

@Injectable({
    providedIn: 'root',
})
export class SocialTabService  {

    cmsUrl = '';

    constructor(
        public http: HttpClient,
        private apiService: ApiService,
    ) {
        this.cmsUrl = environment.cmsUrl;
    }

    getDataApi(): Observable<any[]> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };
        return this.http.get<any[]>(this.cmsUrl + 'media', httpOptions);
    }

    hitApi(type: any, id: any) {
        firstValueFrom(this.http.get(this.cmsUrl + `media/hits/${type}/${id}`));
    }

    async getAllPicks() {
        try {
            const result = await this.apiService.getAllPicks();
            const pickList = result.payload as IPicksResponsePayload;
            Object.keys(pickList.picks).forEach(key => {
                const endTime = pickList.picks[key].endTime;
                const modified = this.convertTime(endTime);
                pickList.picks[key].endTime = modified;
            });

            return pickList.picks;
        } catch(error) {
            console.error(error);
        }
    }

    async getStakings() {
        try {
            const result = await this.apiService.getAllStakings();
            const stakingsList = result.payload as IStakingResponsePayload;
            Object.keys(stakingsList.stakings).forEach(key => {
                const eventDate = stakingsList.stakings[key].eventDate;
                const convertedDate = this.convertTime(eventDate);
                stakingsList.stakings[key].eventDate = convertedDate;
            });
            return stakingsList.stakings;
        } catch(error) {
            console.log(error);
        }
    }

    convertTime(input: FirebaseFirestore.Timestamp): Timestamp {
        const altTime = input as unknown as IAlternateTimestamp;
        const converted = new Timestamp(altTime._seconds, altTime._nanoseconds);
        return converted;
    }

    getPicksTimer(time: Timestamp) {
        const pickTime = time.toMillis();
        const timerObs = this.apiService.getServerTimeObservable().pipe(map(pickTime => pickTime * 1000));
        return timerObs.pipe(
            map(currentTime => {
                const differenc: number = (pickTime-currentTime)/1000;
                if (differenc <= 0 || isNaN(differenc)) return '--:--:--';
                const hours = Math.floor(differenc / 3600);
                const minutes = Math.floor(differenc / 60) % 60;
                const seconds = Math.floor(differenc % 60);

                const hrs = ('0' + hours).slice(-2);
                const min = ('0' + minutes).slice(-2);
                const sec = ('0' + seconds).slice(-2);
                const countdown = hrs + ':' + min + ':' + sec;
                return countdown;
            }),
            distinctUntilChanged(),
        )
    }
}

interface IAlternateTimestamp {
    _seconds: number,
    _nanoseconds: number,
}
